// extracted by mini-css-extract-plugin
module.exports = {"highlightText":"highlightText--F34dc"};